import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  LinearProgress
} from '@mui/material';

interface NutritionItem {
  id: number;
  value: string;
  label: string;
  progress: number;
  borderColor: string;
}

const NutritionTargets: React.FC = () => {
  const nutritionData: NutritionItem[] = [
    {
      id: 1,
      value: '2,100',
      label: 'Calories/Day',
      progress: 87,
      borderColor: '#28a745'
    },
    {
      id: 2,
      value: '65g',
      label: 'Protein/Day',
      progress: 92,
      borderColor: '#dc3545'
    },
    {
      id: 3,
      value: '310g',
      label: 'Carbs/Day',
      progress: 78,
      borderColor: '#ffc107'
    },
    {
      id: 4,
      value: '95%',
      label: 'Vitamin A RDA',
      progress: 95,
      borderColor: '#17a2b8'
    },
    {
      id: 5,
      value: '18mg',
      label: 'Iron/Day',
      progress: 89,
      borderColor: '#28a745'
    },
    {
      id: 6,
      value: '1,200mg',
      label: 'Calcium/Day',
      progress: 76,
      borderColor: '#28a745'
    }
  ];

  return (
    <Card sx={{ height: '100%', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          Nutrition Targets
        </Typography>

        <Grid container spacing={2}>
          {nutritionData.map((item) => (
            <Grid item xs={12} sm={6} md={12} key={item.id}>
              <Box
                sx={{
                  backgroundColor: '#f8f9fa',
                  p: 2,
                  borderRadius: 2,
                  borderLeft: `4px solid ${item.borderColor}`
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                  {item.value}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {item.label}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={item.progress}
                  sx={{
                    height: 8,
                    borderRadius: 1,
                    backgroundColor: '#e9ecef',
                    '& .MuiLinearProgress-bar': {
                      background: 'linear-gradient(90deg, #28a745, #20c997)',
                      borderRadius: 1
                    }
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Weekly Compliance
          </Typography>
          <Box
            sx={{
              backgroundColor: '#e8f5e8',
              p: 2,
              borderRadius: 2
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
              This Week: 91.2% Nutrition Compliance
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Excellent protein targets
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Need more calcium sources
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Iron fortification on track
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NutritionTargets;
